var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tracking row justify-center"},[(_vm.$q.screen.gt.xs)?_c('TileBar',{attrs:{"option-button":"Back"},on:{"on-button":function($event){return _vm.$router.go(-1)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }